// extracted by mini-css-extract-plugin
module.exports = {"shotTitle":"ShotTitle_shotTitle__jcStY","shotLink":"ShotTitle_shotLink__2TWaa"};